type ColorValue = string;
export const enum AppStylesType {
  TEXT = "text",
  COLOR = "color",
  SHADOW = "shadow",
  IMAGE = "image",
}
export const enum ScreenType {
  DESKTOP = "desktop",
  TABLET = "tablet",
  MOBILE = "mobile",
}
export const enum AppStylesCategory {
  TITLE_LARGE = "title_large",
  TITLE_MEDIUM = "title_medium",
  BODY_LARGE = "body_large",
  BODY_MEDIUM = "body_medium",
  CLICK_LOGO = "click_logo",
  // use this options for user defined styles
  CUSTOM = "custom",
}
/**
 * @see https://reactnative.dev/docs/text#style
 */
export type TextStyleValue = {
  color?: string;
  fontFamily?: string;
  fontSize?: number;
  fontStyle?: 'normal' | 'italic';
  /**
   * Specifies font weight. The values 'normal' and 'bold' are supported
   * for most fonts. Not all fonts have a variant for each of the numeric
   * values, in that case the closest one is chosen.
   */
  fontWeight?: 'normal' | 'bold' | '100' | '200' | '300' | '400' | '500' | '600' | '700' | '800' | '900' | number | string;
  letterSpacing?: number;
  lineHeight?: number;
  textAlign?: 'auto' | 'left' | 'right' | 'center' | 'justify';
  textDecorationLine?: 'none' | 'underline' | 'line-through' | 'underline line-through';
  textDecorationStyle?: 'solid' | 'double' | 'dotted' | 'dashed';
  textDecorationColor?: string;
  textShadowColor?: string;
  textShadowOffset?: { width: number; height: number };
  textShadowRadius?: number;
  textTransform?: 'none' | 'capitalize' | 'uppercase' | 'lowercase';
}

/**
 * Color value
 */
export type ColorStyleValue = {
  color: string;
};

/**
 * @see https://reactnative.dev/docs/view#style
 * @see https://github.com/facebook/react-native/blob/master/Libraries/Components/View/ViewStylePropTypes.js
 */
export type ShadowStyleValue = {
  /**
   * Sets the drop shadow color
   * @platform ios
   */
  shadowColor: ColorValue;

  /**
   * Sets the drop shadow offset
   * @platform ios
   */
  shadowOffset: { width: number; height: number };

  /**
   * Sets the drop shadow opacity (multiplied by the color's alpha component)
   * @platform ios
   */
  shadowOpacity: number;

  /**
   * Sets the drop shadow blur radius
   * @platform ios
   */
  shadowRadius: number;
  /**
   * Sets the elevation of a view, using Android's underlying
   * [elevation API](https://developer.android.com/training/material/shadows-clipping.html#Elevation).
   * This adds a drop shadow to the item and affects z-order for overlapping views.
   * Only supported on Android 5.0+, has no effect on earlier versions.
   *
   * @platform android
   */
  elevation?: number;
};
/**
 * File uploaded
 */
export type FileUploaded = {
  filename?: string;
  size?: number;
  url: string;
};
export type ImageStyleValue = FileUploaded;
export type AppStylesValue = TextStyleValue | ColorStyleValue | ShadowStyleValue | ImageStyleValue;
export type AppStylesModelType = {
  /**
   * Generated unique id
   */
  id: string;
  /**
   * App id
   */
  appId: string;
  /**
   * Name of the style
   */
  name: string;
  /**
   * Category of the style
   */
  category: AppStylesCategory;
  /**
   * Type of the style
   */
  type: AppStylesType;
  /**
   * Screen type of the style
   */
  screenType: ScreenType;
  /**
   * Value of the style
   */
  value: AppStylesValue;
  /**
   * Created at, ISO 8601
   */
  createdAt: string;
  /**
   * Updated at, ISO 8601
   */
  updatedAt: string;
};
